import { useEffect } from 'react';
import { useFormV2 } from '@abyss/web/hooks/useForm';
import { AlertService } from '@src/api/common/AlertService';
import {
  GridDefaultColumns,
  IGridBuilderProps,
} from '@src/components/global/GridBuilder/interfaces/IGridBuilderProps';
import { AlertVariantType } from '@src/constants/AlertVariantType';
import { ApiStatus } from '@src/constants/ApiStatus';
import { UrlService } from '@src/api/common/UrlService';
import { TechnologyService } from '@src/api/web-services/features/admin/Technology';
import { PageTitleService } from '@src/api/common/PageTitleService';
import { BreadcrumbService } from '@src/api/common/BreadcrumbService';
import { Breadcrumbs, Title } from './PageInfo';

export const TechnologyGridController = () => {
  const { AlertModel, ShowAlert } = AlertService();
  const { GetTechnologyAll } = TechnologyService();
  const { UpdatePageTitle } = PageTitleService();
  const { UpdateBreadcrumb } = BreadcrumbService();

  const form = useFormV2({
    defaultValues: {
      name: '',
    },
  });

  const DataSource = {
    GridApiMethod: async () => {
      const body = form.getValues();
      const suffix = UrlService.BuildQuery(body);
      const apiData = await GetTechnologyAll(suffix);
      if (apiData.status === ApiStatus.Success && apiData.data?.results) {
        const response = apiData.data.results;
        return response;
      }
      AlertModel.variant = AlertVariantType.ERROR;
      AlertModel.message = apiData.message
        ? apiData.message
        : apiData.data.message;
      AlertModel.visible = true;
      AlertModel.isPermanent = true;
      await ShowAlert(AlertModel);
      return [];
    },
  };

  const gridProps: IGridBuilderProps = {
    gridName: 'technology-grid',
    columns: [
      {
        field: 'id',
        heading: '',
        width: 60,
        disableSort: true,
        link: {
          url: `/admin/technology/`,
          showValue: false,
          appendValueInUrl: true,
          icon: 'edit',
        },
      },
      { field: 'name', heading: 'Name', width: 400 },
      { field: 'isActive', heading: 'Active', width: 200 },
      GridDefaultColumns.CreatedDate,
      GridDefaultColumns.CreatedBy,
      GridDefaultColumns.UpdatedDate,
      GridDefaultColumns.UpdatedBy,
    ],
    gridHeading: 'Technology',
    gridOptionName: 'technology-grid-options',
    gridApiMethod: DataSource.GridApiMethod,
    form,
    createNewButton: {
      text: 'Create New',
      url: `/admin/technology/0`,
    },
  };

  const Action = {
    InIt: async () => {
      await UpdatePageTitle(Title);
      await UpdateBreadcrumb(Breadcrumbs);
    },
  };

  useEffect(() => {
    Action.InIt();
  }, []);

  return { form, gridProps };
};
